export const HEADER_SEARCH_FIELD_ID = 'search-field';
export const HEADER_SEARCH_FIELD_MOBILE_ID = 'search-field-small';

export const HEADER_MAIN_NAVIGATION_ID = 'header-main-nav';

export const MAIN_CONTENT_CONTAINER_ID = 'main';

export const POPOVERS_CONTAINER_ID = 'popovers-container';
export const MODALS_CONTAINER_ID = 'modals-container';
